import CommunicationLogList from "../../components/Communication/CommunicationList";

export default function Communication(){
    return(
        <div>
            <CommunicationLogList/>
        </div>
    )
} 

